import { composeFieldPath } from '@northfork/basics'
import { Basis } from '../../mvt-basis.model'
import { TransferPurchaseInfo } from '../../single-transaction/security-transfer/transfer-purchase-info.model'
import { BulkLoadTransactionDerived } from '../bulk-transaction'
export const loadField = composeFieldPath([] as BulkLoadRow[])

export interface BulkLoadRow {
  //transaction details
  rowId: string
  rowNumber?: string
  smType: string //security
  assetId: string
  securityId: number
  currencyCode: string //security
  entryDate: string
  accountId: number
  tranType: string
  units: number | ''
  factor: number //security
  marketValue: number | ''
  transferPrice: number | ''
  currentUnits: number | ''
  // PVAL-26104: server-derived proceeds amount captured from the derivedFields
  // response, carried into the save command so a cash-affecting load persists
  // its non-zero cash amount. Cleared at the top of every derive cycle
  // (reset-then-apply), so it only ever holds a value the CURRENT derive
  // returned. When a derive cycle produces nothing, the save command falls back
  // to the amount already on the transaction being edited (see
  // prepareBulkTransactionData) rather than omitting the field.
  derivedAmount?: number
  validityStatus: 'valid' | 'invalid' | 'warning' | 'inactive' | 'intermediate'
  errorMessageMap: Map<string, string[]>
  legacyOrigTranId: number
  transactionId: string
  legacyTranId: number
  counterPartyId: number
  counterParty?: string
  inventoryType: string
  clientLotId?: string | null | ''
  collateralBroker?: string
  // security details
  issueDate?: string
  maturityDate?: string
  ticker?: string
  figi?: string
  isin?: string
  sedol?: string
  clearedDate?: string
  orderId?: string
  prepaidInterest?: number
  interestDue?: number
  interestBearingInterestReserve?: number
  interestBearingPrincipalReserve?: number
  nonInterestBearingInterestReserve?: number
  nonInterestBearingPrincipalReserve?: number
  transactionBasis?: string
}

export interface ErrorMessageRow {
  field: string
  errorMessages: string[]
}

export interface BulkDerivedRequest {
  tranData: BulkDerivedRequestEntry[]
  accountBases: { [key: string]: Basis[] }
}

export interface BulkDerivedRequestEntry {
  transaction: BulkLoadTransactionDerived
  tpiDataMap: { [key: string]: TransferPurchaseInfo }
}

export interface BulkDerivedResponse {
  transactionDerivedFields: DerivedTransactionData
  tpiDerivedFields: { [key: string]: DerivedTpiData }
}

export interface DerivedTransactionData {
  transferPrice?: number
  factor: number
  marketValue?: number
  currentUnits?: number
  // PVAL-26104: proceeds amount the backend now derives server-side for a
  // cash-affecting load. Deserialized so the UI can carry it into the save
  // command; the UI never recomputes it.
  amount?: number
}

export interface DerivedTpiData {
  amortStartPrice?: number
  origYield?: number
  amortStartCost?: number
  origPrice?: number
  origCost?: number
}
